export { TruncateModule, TRUNCATE_PIPES } from './truncate.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ng2-truncate/dist/index.js
// module id = ../../../../ng2-truncate/dist/index.js
// module chunks = 11